import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";

import styled from "styled-components/macro";

import { useManagePaymentMethods } from "Payments/ManagePaymentMethods/ManagePaymentMethodsContext";
import BankAccount from "Payments/ManagePaymentMethods/PaymentMethod/CardBackgrounds/BankAccount";
import WePayACHPlaidModal from "Payments/ManagePaymentMethods/WePayACHPlaidModal";
import { useBankProvider } from "Payments/globalPaymentsStateHooks";
import { motion } from "framer-motion";

import ACHEntry from "./ACHEntry/ACHEntry";
import UpdatingPill from "./UpdatingPill";
import { useCardType, usePaymentType } from "./paymentMethodStateHooks";

import { usePaymentMethodState } from ".";

AddPaymentMethodBankAccountEntry.propTypes = {
  setInputErrors: PropTypes.func,
  initialPaymentType: PropTypes.string,
};

export default function AddPaymentMethodBankAccountEntry({
  setInputErrors,
  initialPaymentType,
}) {
  const {
    paymentMethodID,
    cardType,
    paymentType,
    last4,
    isDefaultPaymentMethod,
    isSharedWithHousehold,
    nickname,
    userID,
    setState,
    submitting,
    showUpdateUI,
  } = usePaymentMethodState();
  const { dispatch } = useManagePaymentMethods();
  const { providerIsStax, providerIsWePay } = useBankProvider();
  const { setPaymentType } = usePaymentType();
  const { setCardType } = useCardType();

  const [showPlaidModal, setShowPlaidModal] = useState(false);

  const setPaymentMethodTokenInfo = (info) => {
    if (!info.error) {
      // console.log("info", info);
      const newState = convertInfo(info, providerIsStax);

      setState({ ...newState, ccReadyToSubmit: true });
    } else {
      setState({ submitting: false });
    }
  };

  const handleEditButtonClick = () => {
    if (providerIsStax) {
      console.log("stax");
      return;
    }

    setShowPlaidModal(true);
  };

  const handleWePayTokenCreation = (resp) => {
    //console.log({ resp, ID, paymentMethodID });
  };

  const handleSavedPaymentMethod = (resp) => {
    // const newPaymentMethod = resp.paymentMethods.find(
    //   (pm) => pm.ID === resp.newPaymentMethodID
    // );
    dispatch({
      type: "Set Payment Methods",
      payload: resp.paymentMethods.sort((PM) =>
        PM.isDefaultPaymentMethod ? -1 : 0
      ),
    });
  };

  const shouldSetInitialPaymentType = useMemo(() => {
    return initialPaymentType && !paymentType && providerIsStax;
  }, [initialPaymentType, paymentType, providerIsStax]);

  useEffect(() => {
    if (!shouldSetInitialPaymentType) return;

    // used to force ui to show ACH entry form
    setPaymentType(initialPaymentType);
    if (!cardType) {
      setCardType("checking");
    }
  }, [
    initialPaymentType,
    setPaymentType,
    shouldSetInitialPaymentType,
    setCardType,
    cardType,
  ]);

  if (paymentType !== "bank") return null;

  return (
    <BankAccountCard>
      {showUpdateUI && <UpdatingPill />}

      <ContentWrapper>
        <BankAccount />
        <Content>
          <ACHEntry
            cardType={cardType}
            handleEditButtonClick={handleEditButtonClick}
            last4={last4}
            setInputErrors={setInputErrors}
            setPaymentMethodTokenInfo={setPaymentMethodTokenInfo}
            getPaymentMethodTokenTrigger={submitting}
          />
        </Content>
      </ContentWrapper>

      {providerIsWePay && (
        <WePayACHPlaidModal
          show={showPlaidModal}
          setShow={setShowPlaidModal}
          onTokenCreation={handleWePayTokenCreation}
          onSave={handleSavedPaymentMethod}
          existingPaymentMethodID={paymentMethodID}
          shouldSavePaymentMethod
          additionalSettings={{
            isDefaultPaymentMethod,
            sharedWithOtherHoH: isSharedWithHousehold,
            nickname,
          }}
          userID={userID}
        />
      )}
    </BankAccountCard>
  );
}

const BankAccountCard = styled(motion.div)`
  position: relative;
  //max-width: min(400px, calc(100% - 24px));
  margin: 0 auto;
  user-select: none;
  box-sizing: border-box;
`;

const ContentWrapper = styled(motion.div)`
  width: 100%;
  position: relative;
  background: linear-gradient(
    to right top,
    #280537,
    #56034c,
    #890058,
    #bc005b,
    #eb1254
  );
  aspect-ratio: 85.6 / 53.98;
  border-radius: 18px;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.4) 0 2px 4px;
  box-sizing: border-box;
  padding: 4px;
  color: #fff;
  overflow: hidden;
`;

const Content = styled.div`
  position: relative;
  z-index: 100;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

function convertInfo(info, providerIsStax) {
  if (!providerIsStax) return info;

  return {
    ...info,
    paymentMethodToken: info.id,
  };
}
